import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import {
  getReviews,
  deleteSelectedReview,
  updateReview,
  resetReviews,
} from '../../actions/adminReviews';
import { Row, Col, Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

const Reviews = (props: any) => {
  const history = useHistory();

  const [reviews, setReviews] = useState([]);
  const [deleteReviewModal, setDeleteReviewModal] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [showDeleteLoading, setShowDeleteLoading] = useState(false);
  const [page, setPage] = useState(1);

  const prevAdminReviewsRef = useRef<any>(null);

  // componentDidMount
  useEffect(() => {
    props.getReviews(1);
    // componentWillUnmount
    return () => {
      props.resetReviews();
    };
  }, []);

  // componentDidUpdate: adminReviews.reviews changed
  useEffect(() => {
    if (prevAdminReviewsRef.current === props.adminReviews.reviews) return;
    const prevReviews = prevAdminReviewsRef.current;
    prevAdminReviewsRef.current = props.adminReviews.reviews;

    if (prevReviews !== null && props.adminReviews.reviews !== prevReviews) {
      setReviews(props.adminReviews.reviews);

      if (
        deleteId !== '' &&
        props.adminReviews.reviews.filter((review: any) => review._id === deleteId).length === 0
      ) {
        setDeleteId('');
        setDeleteReviewModal(false);
        setShowDeleteLoading(false);
      }
    }
  });

  const loadMore = (e: any) => {
    const nextPage = page + 1;
    setPage(nextPage);
    props.getReviews(nextPage);
  };

  const handleDeactive = (review: any) => {
    let data: any = {};
    data.isActive = false;
    props.updateReview(review._id, data);
  };

  const handlePublish = (review: any) => {
    let data: any = {};
    data.isActive = true;
    props.updateReview(review._id, data);
  };

  const deleteReview = () => {
    setShowDeleteLoading(true);
    props.deleteSelectedReview(deleteId);
  };

  const handleDeleteClick = (review: any) => {
    setDeleteId(review._id);
    setDeleteReviewModal(true);
  };

  const handleDeleteModal = (e: any) => {
    setDeleteReviewModal(!deleteReviewModal);
  };

  const capitalizeFirstLetter = (string: any) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const capitalizeLastName = (string: any) => {
    return string.charAt(0).toUpperCase() + '.';
  };

  const handleProductClick = (product: any) => {
    history.push({
      pathname: `/adminpanel/products/${product.name.replace(/[^A-Z0-9]+/gi, '-')}/${product._id}`,
    });
  };

  const handleUserClick = (review: any) => {
    history.push({
      pathname: `/adminpanel/users/${review.userId.firstName}${review.userId.lastName}/${review.userId._id}`,
    });
  };

  return (
    <div>
      <div>
        <Modal isOpen={deleteReviewModal} toggle={handleDeleteModal}>
          <ModalBody>Are you sure you want to delete this review?</ModalBody>
          <ModalFooter>
            <Button color="success" onClick={deleteReview} disabled={showDeleteLoading}>
              {showDeleteLoading ? 'Please Wait' : 'Yes'}
            </Button>
            <Button color="danger" onClick={handleDeleteModal} disabled={showDeleteLoading}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
      <Row className="w-100">
        <Col>
          {reviews.length === 0 ? (
            <div className="text-center  my-5">
              <h5>No results found.</h5>
            </div>
          ) : (
            <div className="table-responsive bg-light" style={{ borderRadius: 10 }}>
              <table className="table">
                <thead className="table-borderless">
                  <tr>
                    <th>RATING</th>
                    <th style={{ width: '40%' }}>REVIEW</th>
                    <th>DATE</th>
                    <th>IMAGE</th>
                    <th>REVIEW STATUS</th>
                    <th> </th>
                  </tr>
                </thead>
                <tbody>
                  {reviews.map((review: any) => (
                    <React.Fragment key={review._id}>
                      <tr className="admin-each-product" style={{ cursor: 'pointer' }}>
                        <td style={{ verticalAlign: 'middle' }} className="font-weight-bold">
                          {review.rating && (
                            <span style={{ fontSize: '18px', display: 'inline-block' }}>
                              {[...Array(Math.ceil(review.rating))].map((star, index) => (
                                <i
                                  key={index}
                                  className="fas fa-star"
                                  style={{ color: 'gold' }}
                                ></i>
                              ))}
                              {[...Array(Math.ceil(5 - review.rating))].map((star, index) => (
                                <i
                                  key={index}
                                  className="far fa-star"
                                  style={{ color: 'gold' }}
                                ></i>
                              ))}
                            </span>
                          )}
                        </td>
                        <td style={{ verticalAlign: 'middle' }} className="font-weight-bold">
                          {capitalizeFirstLetter(review.review)} <br />
                          <span className="text-muted">
                            <span
                              className="admin-review-product-name"
                              onClick={() => handleUserClick(review)}
                            >
                              {capitalizeFirstLetter(review.firstName)}{' '}
                              {capitalizeLastName(review.lastName)}
                            </span>{' '}
                            on{' '}
                            <span
                              className="admin-review-product-name"
                              onClick={() => handleProductClick(review.product)}
                            >
                              {review.product.name}
                            </span>
                          </span>
                        </td>
                        <td style={{ verticalAlign: 'middle' }} className="font-weight-bold">
                          {moment(review.lastUpdated).format('Do MMM YY')}
                        </td>
                        <td style={{ verticalAlign: 'middle' }} className="font-weight-bold">
                          {review.reviewImage && review.reviewImage !== '' && (
                            <img
                              src={review.reviewImage}
                              className="img-fluid"
                              style={{ maxHeight: 75 }}
                              alt={capitalizeFirstLetter(review.review)}
                            />
                          )}
                        </td>
                        <td
                          style={{ verticalAlign: 'middle' }}
                          className={
                            !review.isActive
                              ? 'text-warning font-weight-bold'
                              : review.isActive && 'text-success font-weight-bold'
                          }
                        >
                          {' '}
                          {review.isActive ? 'Published' : 'Not Active'}
                        </td>
                        <td
                          style={{ verticalAlign: 'middle' }}
                          className="font-weight-bold text-center"
                        >
                          {!review.isActive ? (
                            <Button
                              className="my-1"
                              color="success"
                              size="sm"
                              onClick={() => handlePublish(review)}
                            >
                              {' '}
                              Publish
                            </Button>
                          ) : (
                            <Button
                              className="my-1"
                              color="info"
                              size="sm"
                              onClick={() => handleDeactive(review)}
                            >
                              {' '}
                              Deactivate{' '}
                            </Button>
                          )}

                          <Button
                            size="sm"
                            className="ml-2 my-1"
                            onClick={() => handleDeleteClick(review)}
                            color="danger"
                          >
                            Delete
                          </Button>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Col>
      </Row>

      <Row>
        <Col className="text-center my-3">
          {props.adminReviews.reviewCount > props.adminReviews.reviews.length && (
            <Button onClick={loadMore} outline color="dark">
              Load More
            </Button>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  adminReviews: state.adminReviews,
});

export default connect(mapStateToProps, {
  getReviews,
  deleteSelectedReview,
  updateReview,
  resetReviews,
})(Reviews);
